import React from "react"
import {findDOMNode} from "react-dom"
import Popover from "../../../../../../gd-components/gd-popover/popover-v2"
import PopoverPosition from "../../../../../../gd-components/gd-popover/popover-position"
import ProjectColorSelector from "../../../../../../gd-components/selector/project-color-selector/project-color-selector";
import ProjectSession from "../../../../../../model2/project/project-session";
import {FieldPopoverMenuProps} from "../../../../../generic/dropdown/components/popover/popover-menu";

export default function FieldProjectColor_Popover(props: FieldPopoverMenuProps) {

    const onChange = (color: string) => {
        props.parent.hidePopover();
        props.parent.onValueChange(color);
    }

    return (
        <Popover position          = {new PopoverPosition({attachment: "top center", targetAttachment: "bottom center"})}
                 getTargetFunc      = {()=>findDOMNode(props.parent)}
                 onClickOutside     = {()=>{props.parent.hidePopover()}}>

            <ProjectColorSelector project       = {props.model as ProjectSession}
                                  onChange      = {onChange}
                                  hidePopover   = {props.parent.hidePopover}/>
        </Popover>
    )
}
